/* src/app/shared/components/campus-principal-info/campus-principal-info.component.scss */
.principal-card {
  padding: 8px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.mat-card-title {
  font-weight: bold;
}
.mat-card-subtitle {
  color: gray;
}
mat-card-header {
  margin-bottom: 20px;
}
mat-card-content label {
  min-width: 100px;
}
mat-card-content span,
mat-card-content a {
  font-weight: 600;
  color: #333;
  text-decoration: none;
}
.email a {
  color: #1976d2;
}
.email a:hover {
  text-decoration: underline;
}
.name {
  margin: 0;
}
.start-date {
  margin-top: 0;
}
mat-card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
mat-card-content > div {
  margin-top: 10px;
}
/*# sourceMappingURL=campus-principal-info.component.css.map */
